import type { DemoKey } from '../types';

export const fr: Partial<Record<DemoKey, string>> = {
  'app.eyebrow': 'Maths · Statistiques',
  'app.title': 'Statistiques',
  'panel.experiment': 'Scène',
  'panel.params': 'Paramètres',

  'exp.survey-explorer.title': 'Explorateur d’enquête',
  'exp.survey-explorer.desc': 'Choisis une colonne ; la démo choisit le bon résumé.',
  'exp.distribution-sculptor.title': 'Sculpteur de distributions',
  'exp.distribution-sculptor.desc': 'Déplace des points et observe la réaction des statistiques.',
  'exp.two-variable-lab.title': 'Laboratoire bivarié',
  'exp.two-variable-lab.desc': 'Nuage, ajustement, et la question du lien de cause.',
  'exp.sampling-lab.title': 'Laboratoire d’échantillonnage',
  'exp.sampling-lab.desc': 'Comment la technique et la taille déplacent la moyenne d’échantillon.',
  'exp.probability-diagrams.title': 'Diagrammes de probabilité',
  'exp.probability-diagrams.desc': 'Vues Venn et arbre pour événements composés.',

  'type.qualitative-nominal.label': 'Qualitatif · nominal',
  'type.qualitative-nominal.def': 'Catégories sans ordre intrinsèque.',
  'type.qualitative-ordinal.label': 'Qualitatif · ordinal',
  'type.qualitative-ordinal.def': 'Catégories avec un ordre significatif.',
  'type.qualitative-multi.label': 'Qualitatif · multi-valeurs',
  'type.qualitative-multi.def': 'Chaque observation peut porter plusieurs étiquettes.',
  'type.quantitative-discrete.label': 'Quantitatif · discret',
  'type.quantitative-discrete.def': 'Nombres par pas fixes.',
  'type.quantitative-continuous.label': 'Quantitatif · continu',
  'type.quantitative-continuous.def': 'Nombres mesurés sur une échelle continue.',

  'column.name.label': 'Nom de l’élève',
  'column.height_cm.label': 'Taille',
  'column.shoe_size_eu.label': 'Pointure (EU)',
  'column.study_hours.label': 'Heures d’étude / semaine',
  'column.test_score.label': 'Note au test',
  'column.sports_played.label': 'Sports pratiqués',
  'column.eye_color.label': 'Couleur des yeux',
  'column.commute_min.label': 'Trajet',
  'column.grade_year.label': 'Classe',
  'column.homework_effort.label': 'Effort aux devoirs',
  'column.ice-cream-sales.label': 'Ventes de glaces',
  'column.drownings.label': 'Noyades',
  'column.month.label': 'Mois',
  'column.storks.label': 'Cigognes',
  'column.births.label': 'Naissances',
  'column.country_area_km2.label': 'Superficie du pays',
  'column.sleep_hours.label': 'Heures de sommeil',
  'column.reaction_ms.label': 'Temps de réaction',

  'dataset.master-survey.label': 'Enquête de classe',
  'dataset.master-survey.desc': '30 élèves simulés.',
  'dataset.spurious-ice-cream-vs-drownings.label': 'Ventes de glaces vs noyades',
  'dataset.spurious-ice-cream-vs-drownings.desc':
    'Les deux montent et descendent avec la saison. Les noyades ne causent pas les ventes de glaces.',
  'dataset.spurious-storks-vs-births.label': 'Cigognes vs naissances',
  'dataset.spurious-storks-vs-births.desc':
    'Les grands pays ont plus de cigognes et plus de naissances. Les oiseaux n’en sont pas la cause.',
  'dataset.real-sleep-vs-reaction-time.label': 'Sommeil vs temps de réaction',
  'dataset.real-sleep-vs-reaction-time.desc':
    'Plus de sommeil, réactions plus rapides. Une vraie corrélation négative — et un mécanisme plausible.',

  'tag.football.label': 'Football',
  'tag.basketball.label': 'Basket',
  'tag.volleyball.label': 'Volley',
  'tag.swimming.label': 'Natation',
  'tag.none.label': 'Aucun',

  'population.gaussian.label': 'Courbe en cloche',
  'population.right-skewed.label': 'Asymétrique à droite',
  'population.bimodal.label': 'Bimodale (avec strates)',
  'population.uniform.label': 'Uniforme',

  'venn.dice-even-or-prime.label': 'Dé : pair ou premier',
  'venn.class-sports-2set.label': 'Sports (2 ensembles)',
  'venn.class-sports-3set.label': 'Sports (3 ensembles)',
  'venn.custom.label': 'Personnalisé',

  'tree.draw-without-replacement.label': 'Tirage sans remise',
  'tree.custom.label': 'Personnalisé',
  'tree.coin.heads': 'F',
  'tree.coin.tails': 'P',
  'tree.draw.start': 'Sac : 2 rouges, 3 bleues',
  'tree.draw.red': 'Rouge',
  'tree.draw.blue': 'Bleu',
  'tree.custom.start': 'Départ',
  'tree.custom.A': 'A',
  'tree.custom.B': 'B',

  'card.histogram': 'Histogramme',
  'card.cumulative': 'Fréquence cumulée',
  'card.box': 'Boîte à moustaches',
  'card.summary': 'Résumé à 5 nombres',
  'card.bar': 'Diagramme en barres',
  'card.mode': 'Mode',
  'card.tag-frequency': 'Fréquence des étiquettes',
  'card.mode-tag': 'Étiquette dominante',
  'card.empty-no-order': 'Non applicable',
  'card.empty-multi': 'Non applicable',
  'card.numberline': 'Droite numérique',
  'card.scatter': 'Nuage',
  'card.description': 'Ce qui se passe',
  'card.population': 'Population',
  'card.sampling-distribution': 'Moyennes d’échantillon',
  'card.venn': 'Venn',
  'card.tree': 'Arbre',
  'card.probabilities': 'Probabilités',

  'param.dataset.label': 'Jeu de données',
  'param.column.label': 'Colonne',
  'param.bins.label': 'Classes',
  'param.shape.label': 'Forme initiale',
  'param.show-mean.label': 'Afficher la moyenne',
  'param.show-median.label': 'Afficher la médiane',
  'param.x-col.label': 'Colonne X',
  'param.y-col.label': 'Colonne Y',
  'param.show-regression.label': 'Droite de régression',
  'param.show-residuals.label': 'Résidus',
  'param.show-confounder.label': 'Afficher le facteur de confusion',
  'param.population.label': 'Population',
  'param.technique.label': 'Technique',
  'param.sample-size.label': 'Taille d’échantillon',
  'param.stratum.label': 'Strate',
  'param.bias.label': 'Biais',
  'param.mode.label': 'Mode',
  'param.preset.label': 'Préréglage',
  'param.universe.label': 'Taille de l’univers',
  'param.show-prob.label': 'Afficher les probabilités',
  'param.treat-as-numeric.label': 'Traiter comme numérique',

  'stat.count': 'Effectif',
  'stat.mean': 'Moyenne',
  'stat.median': 'Médiane',
  'stat.range': 'Étendue',
  'stat.q1': 'Q1',
  'stat.q3': 'Q3',
  'stat.iqr': 'EIQ',
  'stat.outliers': 'Valeurs aberrantes',
  'stat.r': 'r de Pearson',
  'stat.r2': 'r²',
  'stat.slope': 'Pente',
  'stat.intercept': 'Ordonnée à l’origine',
  'stat.n': 'n',
  'stat.population-mean': 'Vraie moyenne',
  'stat.latest-sample-mean': 'Moyenne d’échantillon',
  'stat.sample-mean-spread': 'É-T moyenne d’échantillon',
  'stat.sample-count': 'Échantillons tirés',
  'outlier.upper': 'Aberrantes supérieures',
  'outlier.lower': 'Aberrantes inférieures',

  'region.A': 'A',
  'region.B': 'B',

  'btn.resample': 'Rééchantillonner',
  'btn.run-100': 'Tirer 100 échantillons',
  'btn.stop': 'Arrêter',
  'btn.clear-history': 'Effacer l’historique',

  'explainer.no-order': 'Sans ordre → pas de cumulée, pas de boîte.',
  'explainer.multi-no-iqr': 'Multi-valeurs → quartiles / EIQ non définis.',
  'message.no-data': 'Aucune donnée.',
  'message.needs-quartiles': '≥4 points requis pour les quartiles.',
  'message.x-zero-variance': 'X a une variance nulle — aucune droite à ajuster.',
  'message.n-too-small': 'n trop petit.',
  'message.stratum-clamp': 'La strate avait moins de lignes que demandé — toutes utilisées.',
  'message.siblings-sum-to-one': 'Les enfants doivent sommer à 1.',
};
